export default {
  LAUNCH_RESEARCH({commit}, payload) {
    commit('LAUNCH_RESEARCH', payload)
  },
  LAUNCH_DELIVERY_DETAILS_RESEARCH({commit}, payload) {
    commit('LAUNCH_DELIVERY_DETAILS_RESEARCH', payload)
  },
  RESET_DELIVERY_DETAILS_RESEARCH({commit}, payload) {
    commit('RESET_DELIVERY_DETAILS_RESEARCH', payload)
  },
  RESET_DELIVERY_RESEARCH({commit}, payload) {
    commit('RESET_DELIVERY_RESEARCH', payload)
  },
  RESET_INVOICE_RESEARCH({commit}, payload) {
    commit('RESET_INVOICE_RESEARCH', payload)
  },
  SELECT({commit}, payload) {
    commit('SELECT', payload)
  },
};